import { createAppAsyncThunk } from 'src/store/utils/thunks';
import type { UpdateTaskPayload } from './types';
import { TradingTasksCommands } from './types';
import { wsEsSend } from '@skynet/data-ws-es';

export const pauseTask = createAppAsyncThunk('tradingApiKeys/pauseTask', (id: number, thunkApi) =>
  thunkApi.dispatch(
    wsEsSend({
      command: TradingTasksCommands.PauseTask,
      id,
    }),
  ),
);

export const resumeTask = createAppAsyncThunk('tradingApiKeys/resumeTask', (id: number, thunkApi) =>
  thunkApi.dispatch(
    wsEsSend({
      command: TradingTasksCommands.ResumeTask,
      id,
    }),
  ),
);

export const cancelTask = createAppAsyncThunk('tradingApiKeys/cancelTask', (id: number, thunkApi) =>
  thunkApi.dispatch(
    wsEsSend({
      command: TradingTasksCommands.CancelTask,
      id,
    }),
  ),
);

export const updateTask = createAppAsyncThunk(
  'tradingApiKeys/updateTask',
  (data: UpdateTaskPayload, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: TradingTasksCommands.UpdateTask,
        ...data,
      }),
    ),
);
